import React, { useMemo } from 'react';
import Select from 'react-select';

import { getAlleKnopenFromRBC, getAlleRBCs, getRBCInfo } from '../../utils/voorraadbeheer';

type RbcKnoopSelectFieldProps = {
  value?: string[];
  onSelect: (knopen: string[]) => void;
};

function RbcKnoopSelectField({
  onSelect,
  value = undefined,
  ref,
}: RbcKnoopSelectFieldProps & { ref?: React.Ref<any> }) {
  const options = useMemo(() => {
    return getAlleRBCs().map((rbc) => ({
      label: rbc,
      options: [
        {
          label: `${rbc} toevoegen`,
          value: getAlleKnopenFromRBC(rbc),
        },
        ...getRBCInfo(rbc).flatMap(([knoopgebied, knopen]) => {
          const values = [
            {
              label: `${knoopgebied} toevoegen`,
              value: knopen.map(([_knoop]) => _knoop),
            },
          ];
          for (const [knoop] of knopen) values.push({ label: knoop, value: [knoop] });
          return values;
        }),
      ],
    }));
  }, []);
  return (
    <div style={{ width: '100%' }}>
      <Select
        isMulti
        ref={ref as React.Ref<any>}
        id={`normal-select-rbcknoop`}
        name={'rbcknoop'}
        inputId={'rbcknoop'}
        className='react-select-container'
        classNamePrefix='react-select'
        placeholder={`Voeg RBC, knoopgebied of knopen toe`}
        options={options}
        value={value?.map((val) => ({ label: val, value: [val] }))}
        onChange={(newValue) => {
          const knopen: string[] = Array.from(
            new Set(
              (newValue as unknown as { label: string; value: string[] }[])?.flatMap(
                (selected) => selected?.value ?? [],
              ) ?? [],
            ),
          );
          onSelect(knopen);
        }}
      />
    </div>
  );
}
export default RbcKnoopSelectField;
